export default __webpack_public_path__ + "static/media/fancy slider.d2e06153.png";